<template>
  <div class="mall-icon-button" @click="$emit('click')">
    <img :src="icon" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: 'MallIconButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.mall-icon-button {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
}

.mall-icon-button img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallIconButton.vue